// extracted by mini-css-extract-plugin
module.exports = {"mch-show-more":"styles_mch-show-more__oZvaY","product-shown-info":"styles_product-shown-info__z9Hbr","show-more-btn":"styles_show-more-btn__Y_w_K"};